// 旅居小区（Mock）
// 小区挂在基地下：封面、地址、介绍、配套导语；配套设施为独立集合（类别/名称/图集/简介）
// 旅居是咨询制：无价格、无房态、无预订

export const STAY_COMMUNITY_STATUS = [
  { value: 1, label: '展示', tagType: 'success' },
  { value: 0, label: '下架', tagType: 'info' }
]

// 所属基地选项（与旅居基地列表一致）
export const COMMUNITY_BASE_OPTIONS = [
  { value: 1, label: '那山那水' },
  { value: 2, label: '石林旅居基地' }
]

export const STAY_COMMUNITY_LIST = [
  {
    id: 1,
    base_id: 1,
    name: '象山颐园',
    cover: '',
    address: '桂林市象山区滨江路88号',
    intro: '<p>象山颐园位于广西桂林象山区，是典型的漓江畔宜居社区。这里山清水秀，峰林叠嶂，碧水环绕，素有"桂林山水甲天下，象山山下第一村"的美誉。景区内不仅有壮丽的山水景观，还有淳朴的乡村风情和丰富的民俗文化，是闲暇独家、摄影打卡的理想之地。</p>',
    facility_intro: '<p>舒适居所 · 旅居无忧：精选优质房源，配套齐全，环境优美，让您在桂林住得舒心、安心、放心。</p>',
    sort: 10,
    status: 1,
    created_at: '2026-09-03 09:00:00',
    updated_at: '2026-09-10 15:00:00'
  },
  {
    id: 2,
    base_id: 1,
    name: '漓江雅苑',
    cover: '',
    address: '桂林市叠彩区龙珠路6号',
    intro: '<p>漓江雅苑紧邻漓江，晨起可赏江雾，傍晚可漫步滨江步道。</p>',
    facility_intro: '<p>江景社区，生活便利，步行可达菜市场与公交站。</p>',
    sort: 20,
    status: 1,
    created_at: '2026-09-03 10:00:00',
    updated_at: '2026-09-03 10:00:00'
  },
  {
    id: 3,
    base_id: 2,
    name: '石林康郡',
    cover: '',
    address: '昆明市石林县石林大道12号',
    intro: '<p>石林康郡面向石林风景区，社区园林式布局，配套康养活动中心。</p>',
    facility_intro: '',
    sort: 10,
    status: 0,
    created_at: '2026-09-04 09:00:00',
    updated_at: '2026-09-04 09:00:00'
  }
]

// 配套设施（scope=2 全部挂小区；scope=1 基地层预留）
export const FACILITY_CATEGORY_OPTIONS = ['餐饮', '医疗', '休闲', '出行', '生活服务']

export const STAY_FACILITY_LIST = [
  {
    id: 1,
    scope: 2,
    scope_id: 1,
    category: '餐饮',
    name: '社区食堂',
    images: [],
    intro: '一日三餐，桂林本地口味',
    sort: 10,
    status: 1
  },
  {
    id: 2,
    scope: 2,
    scope_id: 1,
    category: '医疗',
    name: '医务室',
    images: [],
    intro: '常用药与基础诊疗，24小时值守',
    sort: 20,
    status: 1
  },
  {
    id: 3,
    scope: 2,
    scope_id: 1,
    category: '出行',
    name: '接驳车站',
    images: [],
    intro: '往返市区与景区的接驳车停靠点',
    sort: 30,
    status: 1
  },
  {
    id: 4,
    scope: 2,
    scope_id: 2,
    category: '休闲',
    name: '滨江步道',
    images: [],
    intro: '沿漓江而建，晨练散步好去处',
    sort: 10,
    status: 1
  }
]

export function communityStatusText(status) {
  const item = STAY_COMMUNITY_STATUS.find(s => s.value === status)
  return item ? item.label : String(status)
}

export function communityStatusTagType(status) {
  const item = STAY_COMMUNITY_STATUS.find(s => s.value === status)
  return item ? item.tagType : 'info'
}

export function baseLabel(baseId) {
  const item = COMMUNITY_BASE_OPTIONS.find(o => o.value === baseId)
  return item ? item.label : String(baseId)
}
